import Reveal from "@/components/Reveal";
import { Snowflake, ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative border-t border-white/10 overflow-hidden">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-32 pb-12">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-10">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-frost font-bold mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-frost inline-block" />
              Ready when you are
            </p>
            <a
              href="#quote"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase font-medium hover:text-frost transition-colors duration-500"
            >
              Move it cold
              <ArrowUpRight className="w-10 h-10 lg:w-14 lg:h-14 group-hover:translate-x-2 group-hover:-translate-y-2 transition-transform duration-500" strokeWidth={1.25} />
            </a>
          </div>
          <div className="grid sm:grid-cols-2 gap-x-16 gap-y-6 text-sm">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mb-2">Dispatch</p>
              <a href="tel:1800724336" data-testid="footer-phone" className="text-snow font-light hover:text-frost transition-colors duration-300 inline-block">1800 724 336</a>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mb-2">Email</p>
              <a href="mailto:operations@coldfast.com.au" data-testid="footer-email" className="text-snow font-light hover:text-frost transition-colors duration-300 inline-block">operations@coldfast.com.au</a>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mb-2">Hours</p>
              <p className="text-snow font-light">24/7 dispatch — Sydney wide</p>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          data-testid="footer-wordmark"
          className="mt-24 font-display font-semibold uppercase tracking-tighter leading-[0.8] text-[13.5vw] text-outline select-none whitespace-nowrap"
          aria-hidden="true"
        >
          ColdFast
        </div>
      </Reveal>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
        <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
          <Snowflake className="w-3 h-3 text-frost" strokeWidth={1.5} />
          2026 ColdFast Couriers - A Raiden Transport Pty Ltd Company — ABN 22 645 180 276
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist/60" data-testid="footer-placeholder-note">
          Refrigerated transport — Greater Sydney
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
